import { Dashboard as DashboardIcon } from "@volt_developers/react-ui-components";

import { lazyRetry } from "../../../utils/lazyRetry";

import type { Route } from "../../../routes/RouteModel";

const List = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "PayoutsList" */
      /* webpackPrefetch: true */
      "../pages/List"
    ),
  "List"
);

export const payoutsRoutes: Route = {
  i18nName: "List",
  path: "/payouts",
  icon: DashboardIcon,
  component: List,
  newTheme: true,
};
